import { defineStore } from 'pinia';
import { useApi } from '@/lib/api';
import { useGlobalStore } from '@/store/global-store-base';

// Brand lookup tables, cached like other global data. Used e.g. to offer `lookup.<table>.<column>`
// variables in the out-price template panel. SignalrLookupTableTrigger broadcasts LookupTableUpdate on
// any table/row/cell change, so this store revalidates automatically.
export const useLookupTables = defineStore('lookup-tables', () => {
  const api = useApi();
  return useGlobalStore({
    load: api.lookupTable_ListLookupTables,
    dto: 'LookupTableDto',
    signalR: 'LookupTableUpdate',
  });
});
